import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserRankingStats = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解10：统计排名
          </Title>
          <div className="text-lg">
            <p>一、点击成绩排名</p>
            <div className="my-4">
              <Image src="/manual/ranking_stats/1.png" alt="" />
            </div>
            <p>1、成绩排名：汇总后的成绩和排名。</p>
            <p>2、实时排名：记分后的成绩和排名。</p>
            <p>3、轮次：选择总分或各轮次，查看对应的成绩和排名。</p>
            <p>4、下载成绩单：分别以图片格式和 Excel表格格式导出汇总后的排名和成绩单。</p>
            <p>5、显示模式：有极简、精简、详细、单列、两列、三列模式供选择。</p>
            <p>二、导出成绩详情</p>
            <p>点击桌次编排→操作→导出→导出比赛结果，以 Excel表格格式导出详细的比赛数据。</p>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserRankingStats as any, {
  title: '统计排名与导出成绩 · 灵缇赛事系统使用手册',
  description: '灵缇赛事系统统计排名:汇总排名、实时排名、按轮次查看,导出图片与 Excel 成绩单。',
})

export default UserRankingStats
